import React from "react";
import OaLoading from "pages/components/OaLoading";
import PaymentOptions from "./PaymentOptions";
import WebApi, { EXT_REDIRECT_SERVER, POST_PAYGOAL_API_CALLBACK, NSDL_PROCESS_RESPONSE, NSDL_NEW_PAN_REQUEST } from "api/ApiConstants";
import { Grid, makeStyles, useTheme } from "@material-ui/core";
import { localforageGetItem } from "oautils/oaForageUtils";
import { submitDataToPaygoal } from 'pages/module/paymentgateway/Paygoal';
import { submitDataToRazorpay } from 'pages/module/paymentgateway/Razorpay';
import { submitDataToCcAvenue } from "pages/module/paymentgateway/CcAvenue";
import { submitDataToPayU } from "pages/module/paymentgateway/PayU";
import OaPopperAlert from "oahoc/OaPopperAlert";
import OaSnackbar from "oahoc/OaSnackbar";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const PanPaymentDetails = (props) => {

    const intiatingMsg = "Initiating Payment ...";
    const payProcessMsg = "Hold on for a minute!<br/>We’ll get everything done for you";
    const classes = useStyles();
    const theme = useTheme();
    const history = useHistory();

    const [paymentModes, setPaymentModes] = React.useState(null);
    const [selectedPaymentMode, setSelectedPaymentMode] = React.useState(null);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = React.useState(null);
    const [paymentTab, setPaymentTab] = React.useState(0);
    const [grandTotal, setGrandTotal] = React.useState(0);
    const [isLoading, setIsLoading] = React.useState(true);
    const [data, setData] = React.useState(null);
    const [retryPayment, setRetryPayment] = React.useState(false);
    const [userDetails, setUserDetails] = React.useState(null);
    const [responseMessage, setResponseMessage] = React.useState(payProcessMsg);
    const [chargesObj, setChargesObj] = React.useState(null);

    const [severity, setSeverity] = React.useState({
        issuccess: false,
        iserror: false,
        iswarning: false,
        isinfo: false
    });
    const [severitySnackbar, setSeveritySnackbar] = React.useState({
        issuccess: false,
        iserror: false,
        iswarning: false,
        isinfo: false
    });
    const [alertMessage, setAlertMessage] = React.useState("");
    const [finalFormData, setFinalFormData] = React.useState(null);

    const trnRequest = { ...history.location.state.values };

    const switchPaymentTabs = (event, index) => {
        setPaymentTab(index);
        setSelectedPaymentMode(paymentModes[index]);

        if (paymentModes[index].method == "cash") {
            setSelectedPaymentMethod("cashPayment");
        } else {
            for (let gate of paymentModes[index]?.gateway) {
                if (gate.selected) {
                    setSelectedPaymentMethod(gate.method);
                }
            }
        }
    }

    async function showRazorPayWindow(trnResponse) {
        setRetryPayment(false);

        let filteredValue = selectedPaymentMode &&
            selectedPaymentMode.gateway &&
            selectedPaymentMode.gateway.filter((value) => {
                return value.method === selectedPaymentMethod;
            });

        let paymentOptions = filteredValue[0];

        let request = {
            paymentOptions: paymentOptions,
            trnResponse: {
                amountDue: trnResponse.amountDue,
                travelers: [
                    { nameReference: trnRequest.applicantDto.title }
                ],
                deliveryAddress: {
                    firstName: trnRequest.applicantDto.firstName,
                    lastName: trnRequest.applicantDto.lastName,
                    email: trnRequest.otherDetails.emailId,
                    phoneno: trnRequest.otherDetails.telOrMobNo,
                    userType: userDetails?.userTypeAbv,
                    address: "",
                }
            },
            txnId: trnResponse.txnId,
            EncTxnId: trnResponse.encTxnId,
            paymentMode: selectedPaymentMethod,
            uniqueTransactionId: trnResponse.encTxnId,
            transactionId: trnResponse.txnId,
            selectedPaymentMethod: selectedPaymentMethod,
            theme: theme,
            trnType: "pan-application",
            checkoutUrl: trnResponse.paymentUrl
        };

        var response = await submitDataToRazorpay(request);
        setAlertMessage(response.infoText);
        setSeverity({
            ...severity,
            issuccess: response.isSucess,
            iserror: response.isError
        });
        setRetryPayment(response.retryPayment);
        setResponseMessage(response.responseMessage);

        if (response.isSucess) {
            submitData(trnResponse.txnId);
        } else {
            history.push("/pan/payment-status/" + trnResponse.txnId);
        }
    }

    async function showPaygoalWindow(trnResponse) {
        const request = {
            amount: grandTotal,
            encTxnId: trnResponse.encTxnId,
            EncTxnId: trnResponse.encTxnId,
            redirectUrl: EXT_REDIRECT_SERVER + "pan/payment-status/",
            siteUrl: POST_PAYGOAL_API_CALLBACK,
            txnId: trnResponse.txnId,
            paymentMode: "PayGoal",
            failUrl: EXT_REDIRECT_SERVER + "pan/payment-status/",
            checkoutUrl: trnResponse.paymentUrl
        };
        submitDataToPaygoal(request);
    }

    async function showCcAvenueWindow(trnResponse) {
        const request = {
            amount: grandTotal,
            encTxnId: trnResponse.encTxnId,
            EncTxnId: trnResponse.encTxnId,
            redirectUrl: POST_PAYGOAL_API_CALLBACK + "?paymentMode=ccavenue",
            siteUrl: EXT_REDIRECT_SERVER + "pan/payment-status/",
            txnId: trnResponse.txnId,
            paymentMode: "CCAvenue",
            failUrl: EXT_REDIRECT_SERVER + "pan/payment-status/",
            checkoutUrl: trnResponse.paymentUrl
        };
        submitDataToCcAvenue(request);
    }

    async function showPayUWindow(trnResponse) {
        const request = {
            amount: grandTotal,
            encTxnId: trnResponse.encTxnId,
            EncTxnId: trnResponse.encTxnId,
            redirectUrl: POST_PAYGOAL_API_CALLBACK + "?paymentMode=payu",
            siteUrl: EXT_REDIRECT_SERVER + "pan/payment-status/",
            txnId: trnResponse.txnId,
            paymentMode: "PayU",
            trnType: "pan-application",
            checkoutUrl: trnResponse.paymentUrl
        };
        submitDataToPayU(request);
    }

    const displayPaymentWindow = async (trnResponse) => {
        setResponseMessage(intiatingMsg);

        if (selectedPaymentMode.method === "razorpay") {
            showRazorPayWindow(trnResponse);
        }
        if (selectedPaymentMode.method === "paygoal") {
            showPaygoalWindow(trnResponse);
        }
        if (selectedPaymentMode.method === "ccavenue") {
            showCcAvenueWindow(trnResponse);
        }
        if (selectedPaymentMode.method === "payu") {
            showPayUWindow(trnResponse);
        }
    }

    const processPayment = () => {
        if (userDetails) {
            trnRequest.paymentMode = selectedPaymentMethod;
            trnRequest.userType = userDetails?.userTypeAbv;
            trnRequest.partnerId = userDetails?.partnerId;
            trnRequest.requestType = history.location.state.applicationType;
            trnRequest.amountDue = grandTotal;
            trnRequest.applicationType = history.location.state.applicationType;
            trnRequest.siteUrl = EXT_REDIRECT_SERVER + "pan/application/response/";
            trnRequest.redirectUrl = NSDL_PROCESS_RESPONSE;
            // console.log("trnRequest", trnRequest);
            setIsLoading(true);
            new Promise((resolve, reject) => {
                WebApi.nsdlPanCreateTransaction(
                    trnRequest, response => {
                        resolve(response);
                    }, error => {
                        console.log("trn creation error", error);
                        reject(error);
                    });
            }).then(response => {
                setIsLoading(false);
                if (response.success) {
                    if (selectedPaymentMethod == "cashPayment") {
                        submitData(response.data.txnId);
                    } else {
                        displayPaymentWindow(response.data);
                    }
                } else {
                    setAlertMessage("Failed to create transaction. Please retry");
                    setSeverity({
                        ...severity,
                        iserror: true
                    });
                    console.log("error creating transaction", response);
                }
            }).catch(error => {
                console.log("error", error);
                setIsLoading(false);
                setAlertMessage("internal error");
                setSeverity({
                    ...severity,
                    iserror: true
                });
            })

        }
    }

    const initPayment = () => {
        return new Promise((resolve, reject) => {
            localforageGetItem("user-id", function (err, value) {
                WebApi.nsdlPanGetTransCharges(
                    {amountDue: Number(history.location.state?.payableAmount).toFixed(2)}, 
                    response => {
                        if(response.success) {
                            setGrandTotal(Number(response.data.amountDue).toFixed(2));
                            setChargesObj({
                                amountDue: Number(response.data.amountDue).toFixed(2),
                                baseCharges: Number(response.data.baseCharges).toFixed(2),
                                agentComm: Number(response.data.agentComm).toFixed(2),
                                agentMarkup: Number(response.data.agentMarkup).toFixed(2),
                                otherCharges: Number(response.data.supplierGstCharges + 
                                response.data.companyMarkup + response.data.distMarkup).toFixed(2),
                                tdsOnComm: Number(response.data.supplierTdsCharges).toFixed(2)
                            });
                        } else {
                            console.log("Failed getting transaction charges");
                        }
                    }, error => {
                    console.log("error getting transaction charges", error);
                });
                WebApi.getAgentExtendedDetails(
                    { agentId: value },
                    (response) => {
                        if (response.success) {
                            resolve(response.data);
                        } else {
                            reject(err);
                        }
                    }, (error) => {
                        console.log("error", error);
                    }
                );
            });
        });
    }

    const getPgOptions = () => {
        localforageGetItem("user-details", function (err, value) {
            if (value) {
                setUserDetails(value);
                WebApi.getCompanyPGOptions({
                    partnerId: value.partnerId,
                    serviceId: 24,
                }, (response) => {
                    response.data.map((value) => {
                        if (value.selected) {
                            setSelectedPaymentMethod(value.method);
                        }
                    });
                    setPaymentModes(response.data);
                    setIsLoading(false);

                    for (let [payModeIdx, payMode] of response.data.entries()) {
                        if (payMode.selected) {
                            setSelectedPaymentMode(payMode);
                            setPaymentTab(payModeIdx);


                            if (payMode.method == "cash") {
                                setSelectedPaymentMethod("cashPayment");
                            } else {
                                for (let gate of payMode?.gateway) {
                                    if (gate.selected) {
                                        setSelectedPaymentMethod(gate.method);
                                    }
                                }
                            }
                        }
                    }
                }, (error) => {
                    setIsLoading(false);
                    console.log("error getting pg options", error);
                }
                );
            } else {
                console.log("localforage error", err);
            }
        });
    };

    const refreshBalance = () => {
        initPayment.then(extData => setData(extData));
    }

    const submitData = (txnId) => {
        let reqParam = { ...trnRequest };

        delete reqParam.paymentMode;
        delete reqParam.userType;
        delete reqParam.partnerId;
        delete reqParam.requestType;
        delete reqParam.amountDue;
        delete reqParam.applicationType;
        delete reqParam.loggedInUserId;
        // return console.log("trnRequest", reqParam);
        WebApi.nsdlSignRequest({
            formData: JSON.stringify(reqParam),
            redirectUrl: NSDL_PROCESS_RESPONSE,
            siteUrl: EXT_REDIRECT_SERVER + "pan/application/response/",
            requestType: "CR",
            txnId: txnId
        }, response => {
            if (response.success) {
                setFinalFormData(response.data);
                setAlertMessage("Processing application form for submission...");
                setSeveritySnackbar({
                    ...severitySnackbar,
                    issuccess: true
                });
            } else {
                console.log("error response", response);
                setAlertMessage(response.message);
                setSeverity({
                    ...severity,
                    iserror: true
                });
            }
        }, error => {
            console.log("error", error);
        });
    };

    const submitToNsdl = () => {
        console.log("finalFormData", finalFormData)
        var formElement = document.createElement("form");
        formElement.setAttribute("method", "post");
        formElement.setAttribute("action", NSDL_NEW_PAN_REQUEST);
        formElement.setAttribute("target", "_parent");

        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", "req");
        hiddenField.setAttribute("value", finalFormData);
        formElement.appendChild(hiddenField);

        document.body.appendChild(formElement);
        formElement.submit();
    }

    React.useEffect(() => {
        initPayment().then(extData => {
            setData(extData);
            getPgOptions();
        });
    }, []);

    React.useEffect(() => {
        if (finalFormData && finalFormData !== "") {
            submitToNsdl();
        }
    }, [finalFormData]);

    return (
        !isLoading ?
            <div className={classes.root}>
                <Grid container className="payment-details-container">
                    <Grid item md={8} sm={12} xs={12}>
                        <Grid container>
                            <Grid item>
                                <PaymentOptions
                                    paymenttab={paymentTab}
                                    switchpaymenttabs={switchPaymentTabs}
                                    paymentmodes={paymentModes}
                                    isloading={isLoading}
                                    data={data}
                                    selectedpaymentmethod={selectedPaymentMethod}
                                    setselectedpaymentmethod={setSelectedPaymentMethod}
                                    grandtotal={grandTotal}
                                    setisloading={setIsLoading}
                                    refreshBalance={refreshBalance}
                                />
                            </Grid>
                        </Grid>
                        <Grid container className="button-holder">
                            <button className="action-button" onClick={() => processPayment()}>
                                {retryPayment == true ? "Retry payment " : "Pay"} <Rs /> {grandTotal}
                            </button>
                        </Grid>
                    </Grid>
                    <Grid item md={4} sm={12} xs={12}>
                        <div className="charges-breakup-root">
                            <table className="cb-table">
                                <tr>
                                    <td>
                                        <span className="cb-label">GST & Other charges</span>    
                                    </td>
                                    <td>
                                        <span className="cb-value">{chargesObj?.otherCharges}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <span className="cb-label">Commission</span>    
                                    </td>
                                    <td>
                                        <span className="cb-value">{chargesObj?.agentComm}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <span className="cb-label">Markup</span>    
                                    </td>
                                    <td>
                                        <span className="cb-value">{chargesObj?.agentMarkup}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <span className="cb-label bold">Total Payable</span>    
                                    </td>
                                    <td>
                                        <span className="cb-value bold">{grandTotal}</span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </Grid>
                </Grid>

                <OaPopperAlert
                    alertmessage={alertMessage}
                    severity={severity}
                    setseverity={setSeverity}
                />
                <OaSnackbar
                    alertmessage={alertMessage}
                    severity={severitySnackbar}
                    setseverity={setSeveritySnackbar}
                    vertical="bottom"
                    horizontal="right"
                    autoHideDuration={6000}
                />
            </div>
            :
            <div className={classes.loadingRoot}>
                <OaLoading />
            </div>
    );
};

export default PanPaymentDetails;

const Rs = () => {
    return <span style={{ fontFamily: "Roboto" }}>₹</span>
}

const useStyles = makeStyles(theme => ({
    root: {
        width: 1280,
        padding: "70px 0",
        display: "flex",
        justifyContent: "center",
        fontFamily: theme.palette.font.primary,
        [theme.breakpoints.down(1280)]: {
            width: "100%"
        },
        "& .MuiTypography-root, .MuiTab-wrapper": {
            fontFamily: theme.palette.font.primary,
        },
        "& .MuiTab-root": {
            border: `solid 0.5px ${theme.palette.primary.disabled}`
        },
        "& .payment-details-container": {
            maxWidth: 1200
        },
        "& .tab-container": {
            "& .MuiTabs-scrollable": {
                minHeight: 300,
                "& .MuiButtonBase-root.MuiTab-root": {
                    margin: "0 0 10px",
                    "&.Mui-selected": {
                        background: theme.palette.background.rgba_primary,
                    },
                },
                "& .MuiTabs-indicator": {
                    backgroundColor: theme.palette.background.rgba_primary_active,
                },
            },
        },
        "& .tab-panel-container": {
            "& .MuiBox-root": {
                padding: "0 36px",
            },
            "& .tab-content-div": {
                width: "100%",
            },
            "& .MuiRadio-colorSecondary.Mui-checked": {
                "& .MuiSvgIcon-root": {
                    color: theme.palette.primary.main,
                }
            },
        },
        "& .section": {
            marginTop: 20,
            marginBottom: 20,
            paddingLeft: "3vw",
            background: theme.palette.background.light,
            [theme.breakpoints.down(960)]: {
                paddingRight: 10,
                paddingLeft: 10,
            },
        },
        "& .payment-method": {
            cursor: "pointer",
            margin: "15px 0",
            padding: "5px 20px",
        },
        "& .pay-method-title": {
            fontSize: 20,
            fontWeight: 600,
        },
        "& .payment-method-info": {
            fontSize: 12,
            fontWeight: 500,
        },
        "& .button-holder": {
            marginTop: 50,
            justifyContent: "center",
        },
        "& .action-button": {
            background: theme.palette.primary.main,
            padding: "5px",
            textAlign: "center",
            fontFamily: theme.palette.font.primary,
            color: theme.palette.primary.contrastText,
            width: 200,
            height: 45,
            borderRadius: 5,
            fontSize: 22,
            fontWeight: 500,
            appearance: "none",
            MozAppearance: "none",
            WebkitAppearance: "none",
            border: "none !important",
            outline: "none !important",
            cursor: "pointer",
        },
        "& .charges-breakup-root": {
            padding: "0 10px",
            borderLeft: `solid 0.5px ${theme.palette.primary.disabled}`,
            minHeight: "100%"
        },
        "& .cb-table": {
            width: 300,
            "& .cb-label": {
                padding: "5px 0 0",
                fontWeight: 500
            },
            "& .cb-value": {
                padding: "5px 0 0",
                display: "block",
                width: "100%",
                textAlign: "right",
                fontWeight: 500
            }
        },
        "& .bold": {
            fontWeight: "600 !important"
        }
    },
    loadingRoot: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 400,
    },
}));
